export default "__VITE_ASSET__Cblxflam__"